<template lang="pug">
    div.individual-chart(:class="wrapperClass")
        sectionHeader(:title="name")
        v-chart(:option="chartDataSourcesAllocation" autoresize :class="className")
        
</template>

<script>
import SectionHeader from '@/components/common/SectionHeader'
import { ACTIVITY_SOURCES } from '@/utils/constants'

const SOURCES_COLORS = {
    AudienceBootstrap: '#42d4f4',
    Collect: '#808000',
    CustomSegmentBootstrap: '#dcbeff',
    CustomSegmentFrequency: '#fabed4',
    CustomSegmentRemoval: '#fffac8',
    DataEntryManager: '#469990',
    DataService: '#800000',
    GenericCollect: '#aaffc3',
    GenericCollectGCP: '#ffd8b1',
    Marketplace: '#9a6324',
    Other: '#911eb4',
    WeboramaTaxonomies: '#f58231',
    WCM: '#e6194B'
}
const OTHERS_DEFAULT_COLORS = ['#e6194b', '#3cb44b', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff']

export default {
    name: 'AllocationDoughnut',

    components: {
        SectionHeader
    },

    props: {
        name: { type: String, required: true },
        allocationMetrics: { type: Object, required: true },
        className: { type: String, required: false, default: '' }
    },

    computed: {
        wrapperClass() {
            return this.className + '-wrapper'
        },
        chartDataSourcesAllocation() {
            return {
                tooltip: {
                    show: true
                },
                legend: {
                    left: 'center',
                    top: '0',
                    show: true,
                    textStyle: {
                        fontSize: 14
                    },
                    data: Object.keys(this.allocationMetrics.allocationBySignificantProvider),
                    tooltip: {
                        trigger: 'item',
                        show: true,
                        position: { left: 'center', top: '10%' },
                        alwaysShowContent: true,
                        showContent: true,
                        extraCssText: 'max-width: 300px; padding: 10px; white-space: unset; word-break: break-word',
                        formatter({ name }) {
                            if (name === 'Other') return 'Other sources'
                            const fullObject = Object.values(ACTIVITY_SOURCES).find(item => item.source === name)
                            return `${fullObject.hint}`
                        }
                    }
                },
                series: [
                    {
                        name: 'Account audience allocation by source',
                        type: 'pie',
                        itemStyle: {
                            borderRadius: 10,
                            borderColor: '#fff',
                            borderWidth: 2,
                            color: ({ dataIndex, data }) => SOURCES_COLORS[data.name.replaceAll(' ', '')] || OTHERS_DEFAULT_COLORS[dataIndex]
                        },
                        radius: ['80%', '90%'],
                        top: 50,
                        avoidLabelOverlap: true,
                        tooltip: {
                            show: false
                        },
                        label: {
                            show: false,
                            position: 'center',
                            formatter({ percent, name }) {
                                const val = percent < 1 ? '<1' : percent
                                return `${name} : \n ${val}%`
                            }
                        },
                        emphasis: {
                            label: {
                                show: true,
                                fontSize: '16'
                            }
                        },
                        data: Object.entries(this.allocationMetrics.allocationBySignificantProvider).map(([name, value]) => ({ name, value }))
                    }
                ]
            }
        }
    }
}
</script>
